var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { SLButton, SLModal } from '@yy/sl-admin-components';
import { useDataAtomValues, useStateAtom } from '../../state';
import { EBillType, EBillDetailExtOrderType } from '../../constants';
import { useTranslation } from '../../_utils/i18n';
var CancelButton = styled(SLButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 20px;\n"])));
export default function PayCanceller(props) {
  var onPayCancel = props.onPayCancel;
  var _useDataAtomValues = useDataAtomValues(),
    originDetail = _useDataAtomValues.originDetail,
    isBillPending = _useDataAtomValues.isBillPending;
  var _useStateAtom = useStateAtom(),
    _useStateAtom2 = _slicedToArray(_useStateAtom, 2),
    cancelLoading = _useStateAtom2[0].cancelLoading,
    setStateAtom = _useStateAtom2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var cancelBill = function cancelBill() {
    onPayCancel === null || onPayCancel === void 0 ? void 0 : onPayCancel();
  };
  var onCancelBill = function onCancelBill() {
    var _originDetail$extInfo;
    setStateAtom(function (draft) {
      draft.cancelLoading = true;
    });
    var modalOption = {
      title: t('multistores.bill001'),
      okText: t('multistores.bill0014'),
      onOk: cancelBill,
      onCancel: function onCancel() {
        setStateAtom(function (draft) {
          draft.cancelLoading = false;
        });
      }
    };
    if ((originDetail === null || originDetail === void 0 ? void 0 : (_originDetail$extInfo = originDetail.extInfo) === null || _originDetail$extInfo === void 0 ? void 0 : _originDetail$extInfo.orderType) === EBillDetailExtOrderType.autoRecurring && (originDetail === null || originDetail === void 0 ? void 0 : originDetail.billType) === EBillType.subscription) {
      modalOption.content = t('subscriptions.pendingOrder.sureCancelOrder1');
    }
    SLModal.danger(modalOption);
  };

  // 若账单处于支付中，则不可取消

  return /*#__PURE__*/React.createElement(CancelButton, {
    type: "default",
    loading: cancelLoading,
    onClick: onCancelBill,
    disabled: isBillPending
  }, t('settlement.creditbox.cancel'));
}